<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    persistent
    transition="dialog-transition"
    max-width="500px"
  >
    <v-card tile>
      <v-toolbar dense>
        <v-btn @click="closeDialog()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title class="subtitle-1">New Contact</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn class="mr-2 text-none primary darken-4" @click="createContact()">Create</v-btn>
      </v-toolbar>

      <v-card-text class="mx-0 px-0">
        <v-form class="pa-4" ref="form" @submit.prevent v-model="valid" lazy-validation>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            autofocus
            label="Name"
            color="primary darken-4"
            :class="{ 'mb-3': !valid }"
            outlined
            dense
            validate-on-blur
          ></v-text-field>

          <v-text-field
            v-model="phone"
            :rules="phoneRules"
            label="Phone"
            color="primary darken-4"
            :class="{ 'mb-3': !valid }"
            outlined
            dense
            prefix="+233"
            counter="9"
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
            color="primary darken-4"
            :class="{ 'mb-3': !valid }"
            outlined
            dense
          ></v-text-field>
        </v-form>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NewContactDialog",
  data() {
    return {
      valid: true,
      name: "",
      nameRules: [v => !!v || "name is required"],
      phone: "",
      phoneRules: [
        v => !!v || "Enter an active phone number",
        v => !isNaN(v) || "Phone number must be valid",
        v => (v && v.length === 9) || "Phone number must be 9 digits"
      ],
      email: "",
      emailRules: [
        v => !!v || "Email is required",
        v => /.+@.+/.test(v) || "Email must be valid"
      ]
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setNewContactDialog", false);
    },

    async createContact() {
      if (this.$refs.form.validate()) {
        var data = {
          branch: this.branchId,
          name: this.name,
          phone: this.phone,
          email: this.email
        };

        await this.$store.dispatch("createContact", data).then(() => {
          this.$refs.form.reset();
        });
      }
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.contacts.newContactDialog;
    },

    branchId: {
      get() {
        if (this.$route.params.branchId) return this.$route.params.branchId;
        else return "";
      },

      set: function() {
        return;
      }
    }
  }
};
</script>

<style>
</style>